import React from 'react';
import { cn } from '@ui/lib/utils';

interface GridProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
    cols?: 1 | 2 | 3 | 4 | 5 | 6;
    gap?: 2 | 4 | 6 | 8;
}

export function Grid({ children, cols = 1, gap = 6, className, ...props }: GridProps) {
    return (
        <div
            className={cn(
                "grid",
                cols === 1 && "grid-cols-1",
                cols === 2 && "grid-cols-1 lg:grid-cols-2",
                cols === 3 && "grid-cols-1 md:grid-cols-2 lg:grid-cols-3",
                cols === 4 && "grid-cols-1 md:grid-cols-2 lg:grid-cols-4",
                cols === 5 && "grid-cols-2 md:grid-cols-3 lg:grid-cols-5",
                cols === 6 && "grid-cols-2 md:grid-cols-3 lg:grid-cols-6",
                gap === 2 && "gap-2",
                gap === 4 && "gap-4",
                gap === 6 && "gap-6",
                gap === 8 && "gap-8",
                className
            )}
            {...props}
        >
            {children}
        </div>
    );
}
